module.exports = __webpack_public_path__ + "img/error-logo.dfe65e5b.svg";